<template>
  <m-basic-form
    @save="save"
    @remove="remove"
    :loadingMsg="loadingMsg"
    :loadingShow="loadingShow"
    :formId="ID"
  >
    <div class="row">
      <div class="col-5">
        <m-input v-model="form.PRICENAME" langlabel="pricename" />
        <m-input
          v-model="form.PRICE"
          @keyup.native="calcAllPrice"
          type="number"
          langlabel="pricenontax"
        />

        <m-input
          v-model="form.TAXRATE"
          @keyup.native="calcAllPrice"
          type="number"
          langlabel="taxrate"
        />
        <m-input
          v-model="form.TAXAMOUNT"
          readonly
          type="number"
          langlabel="taxamount"
        />
        <m-input
          v-model="form.TOTALAMOUNT"
          readonly
          type="number"
          langlabel="amount"
        />
        <m-yes-no v-model="form.ISACTIVE" langlabel="isactive" />
      </div>
    </div>
  </m-basic-form>
</template>

<script>
import api from "../../api";
import swal from "sweetalert";
export default {
  mounted() {
    if (intval(this.$route.params.id) > 0) {
      this.ID = intval(this.$route.params.id);
      this.getStaticPrice(this.ID);
    }
  },
  data() {
    return {
      ID: null,
      desi: [],
      form: {
        PRICENAME: null,
        PRICE: null,
        TAXRATE: null,
        TAXAMOUNT: null,
        TOTALAMOUNT: null,
        ISACTIVE: 1,
      },
      loadingShow: false,
      loadingMsg: null,
    };
  },
  methods: {
    calcAllPrice() {
      if (
        toNumberFromTr(this.form.PRICE) &&
        toNumberFromTr(this.form.TAXRATE)
      ) {
        this.form.TAXAMOUNT = toTrFromNumber(
          (toNumberFromTr(this.form.PRICE) *
            toNumberFromTr(this.form.TAXRATE)) /
            100
        );
        this.form.TOTALAMOUNT = toTrFromNumber(
          toNumberFromTr(this.form.TAXAMOUNT) + toNumberFromTr(this.form.PRICE)
        );
      }
    },
    save() {
      this.loadingMsg = this.$t("dialog.savingrecord");
      this.loadingShow = true;
      api
        .saveStaticPrice(
          {
            ...this.form,
            PRICE: toNumberFromTr(this.form.PRICE),
            TAXRATE: toNumberFromTr(this.form.TAXRATE),
            TAXAMOUNT: toNumberFromTr(this.form.TAXAMOUNT),
            TOTALAMOUNT: toNumberFromTr(this.form.TOTALAMOUNT),
          },

          this.ID
        )
        .then((res) => {
          if (res.data.status) {
            if (this.ID == res.data.data.ID) {
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullyupdatedrecord"),
                "success"
              );
            } else {
              this.ID = res.data.data.ID;
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullysaverecord"),
                "success"
              );
            }
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    getStaticPrice(id) {
      this.loadingMsg = this.$t("dialog.fetchingdata");
      this.loadingShow = true;
      api
        .getStaticPriceOne(id)
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            const {
              PRICENAME,
              PRICE,
              TAXRATE,
              TAXAMOUNT,
              TOTALAMOUNT,
              ISACTIVE,
            } = res.data.data;
            this.form = {
              PRICENAME,
              PRICE: toTrFromNumber(PRICE),
              TAXRATE: toTrFromNumber(TAXRATE),
              TAXAMOUNT: toTrFromNumber(TAXAMOUNT),
              TOTALAMOUNT: toTrFromNumber(TOTALAMOUNT),
              ISACTIVE,
            };
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    remove() {
      this.loadingMsg = this.$t("dialog.removingrecord");
      this.loadingShow = true;
      api
        .deleteStaticPrice(this.ID)
        .then((res) => {
          if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
  },
};
</script>

<style></style>
